

import React, { Component, useState, useEffect } from "react";
import { Link, useStaticQuery, graphql } from "gatsby"
import Modal from "react-bootstrap/Modal"
import { ImageModule } from "../../../modules/Image_Module"
import { CustomLinks } from "../../../components/common/utils"

import MemberForm from "../../../components/forms/member-form"

const PeopleItem = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [membDet, setMembDet] = useState('');

    const MemberPopup = (item) => {
        setMembDet(item);
        setIsOpen(true);
    }

    const { glstrapi } = useStaticQuery(graphql`
        query CommercialPeopleItemQuery {
            glstrapi {
                peoples(limit: -1) {
                    id
                    Name
                    Email_ID
                    Phone_Number
                    URL
                    Form_Queue_ID
                    Image { url alternativeText }
                    imagetransforms
                    people_departments { id Name }
                    ggfx_results { id content_type transforms src_import_url src_cftle field }
                }
            }
        }
    `)
    const allPeoples = glstrapi?.peoples || [];
    const person = props.email_id
        ? allPeoples.find(p => p.Email_ID?.toLowerCase().includes(props.email_id.toLowerCase()))
        : null;

    return <>
        {
            person &&
            <div className="contact-person">
                <div className="contact-img">
                    <picture>
                        <ImageModule ImageSrc={person.Image} altText={person.Name} ggfx_results={person.ggfx_results} imagename="peoples.Image.home_team_avatar" strapi_id={person.id} />
                    </picture>
                </div>
                <div className="contact-info">
                    <div className="h3">
                        {person.Name}
                    </div>
                    <div className="department"> {person.people_departments?.[0]?.Name}</div>
                    <div className="details">
                        <a href={"tel:" + person.Phone_Number} className="tel">
                            {person.Phone_Number} </a>
                        <span className="slash">/</span>
                        <a href={"javascripti:;"} onClick={() => MemberPopup(person)} className="mail">Email</a><br />
                    </div>

                </div>
            </div>
        }


        <Modal
            id="popup_modal_form"
            show={isOpen}
            onHide={() => setIsOpen(false)}
            backdrop="static"
            keyboard={false}
            className="member-contact-modal"
        >

            <Modal.Header closeButton className="contact-close-btn memberPopup">
                <Modal.Title className="w-100"><h3 className="text-center content-primary-color mb-0">Contact - {membDet.Name}</h3></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <MemberForm to_email_id={membDet?.Email_ID} to_user_id={membDet?.Form_Queue_ID} formName={`Individual Contact - ${membDet?.Name}`} formLabel={`Contact ${membDet?.Name}`} />
            </Modal.Body>
        </Modal>

    </>
}

export default PeopleItem;